import React from 'react';

function SectionTitle({ label, title }) {
  return (
    <div className="section-heading">
      {label && <span className="section-heading__label">{label}</span>}
      <h2
        className="section-heading__title"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div className="section-heading__line"></div>
    </div>
  );
}

export default SectionTitle;